import { useEffect } from 'react';

/**
 * Хук для динамической вставки скрипта в DOM.
 * @param {object} options - Объект с параметрами для вставки скрипта.
 * @param {string} options.src - URL скрипта.
 * @param {string} options.selector - CSS-селектор элемента, куда вставляется скрипт.
 * @param {string} options.type - Тип скрипта.
 * @param {boolean} options.isAsync - Асинхронность.
 * @param {string} options.innerScript - Скрипт внутри тэга.
 */
export const useScriptInsert = (options) => {
  const {
    src,
    selector = 'head',
    type = 'text/javascript',
    isAsync = true,
    innerScript,
  } = options;

  useEffect(() => {
    const container = document.querySelector(selector);
    const isAlreadyExists = src && Boolean(container?.querySelector(`script[src="${src}"]`));

    if (!container || isAlreadyExists || !(src || innerScript)) {
      return;
    }

    const script = document.createElement('script');

    if (src) {
      script.src = src;
    } else {
      script.innerHTML = innerScript;
    }

    script.type = type;
    script.async = isAsync;
    container.appendChild(script);
  }, [src, selector, type, isAsync, innerScript]);
};
